// extracted by mini-css-extract-plugin
export default {"lds_ring":"style_lds_ring__MQfjG"};